import { cn } from '@/lib/utils'
import logoImg from 'assets/logo.png'
import React from 'react'
import { useRole } from '../hooks/auth'

const Nav = React.forwardRef(({ sticky, className, name, ...props }, ref) => {
  const isAdmin = useRole(`admin`)
  return (
    <header
      ref={ref}
      className={cn(
        'top-0 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 p-1 gap-2',
        sticky && 'sticky top-0 z-50',
        className,
      )}
    >
      <div className="flex h-14 w-full min-w-0 items-center gap-2 px-4">
        <a
          className="mr-2 flex shrink-0 items-center space-x-2 sm:mr-4"
          href={isAdmin ? '/admin' : '/personal'}
        >
          <img
            src={logoImg}
            alt="Logo"
            className="d-inline-block h-8 w-8 align-text-top"
          />
          <span className="hidden font-bold sm:inline-block">{name}</span>
        </a>
        <div
          className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden md:justify-end"
          {...props}
        />
      </div>
    </header>
  )
})

Nav.displayName = 'Nav'

export default Nav
